// extracted by mini-css-extract-plugin
module.exports = {"disabled":"EntityPickerWidget_disabled__VO55n","withFloatingLabel":"EntityPickerWidget_withFloatingLabel__1MKsS"};